import { initListeners } from "./input_events";
// import tracking from "./tracking";
const validator = () => {
  const expEmail = /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,4})$/;
  const expZipcode = /^(([0-8][0-9])|(9[0-5]))[0-9]{3}$/;
  const expPhone = /^0[1-79](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
  const expSpChar = /[!@#$%^&*?"{}|<>]/;
  const expSpCharTxt = /[@#$^*{}|<>]/;
  const expNumber = /^\d*$/;
  const expInteger = /^[0-9]+$/;
  const expMonth = /^(19|20)\d\d-(0[1-9]|1[0-2])$/;
  const notkg = document.body.classList.contains('notkg');

  const form = document.querySelector(".form"),
    civBtns = [].slice.call(form.querySelectorAll(".btn--civility"));

  return {
    checkType: input => {
      let isInputValid;
      switch (input.type) {
        case "email":
          isInputValid = validator().validateTypeEmail(input);
          break;
        case "number":
          if (input.classList.contains("form__input--zipcode"))
          {
            isInputValid = validator().validateTypeZipcode(input);
          } else
          {
              if(input.classList.contains("form__input--newzipcode"))
              {
                isInputValid = validator().validateTypeZipcode(input);
              }
              else{
                isInputValid = validator().validateTypeNumber(input);
              }
          }
          break;
        case "radio":
          let label = form.querySelector(`label[for='${input.id}']`);
          validator().validateTypeRadio(input, label, form, civBtns);
          break;
        case "month":
          if (input.classList.contains("form__input--month")) {
            isInputValid = validator().validateTypeMonth(input);
          }
          break;
        case "text":
          if (input.classList.contains("form__input--phone")) {
            isInputValid = validator().validateTypePhone(input);
          } else {
            if (input.classList.contains("form__input--month")) {
              isInputValid = validator().validateTypeMonth(input);
            }
            else{
              isInputValid = validator().validateTypeText(input);
            }
          }
          break;
        case "select-one":
          let selectLabel = form.querySelector(`label[for='${input.id}']`);
          isInputValid = validator().validateTypeNativeSelect(input);
          break;
        default:
          if (input.classList.contains("form__input--message")) {
            isInputValid = validator().validateTypeMessage(input);
          } else {
            isInputValid = validator().validateTypeText(input);
          }
          break;
      }
      if (isInputValid) {
        // tracking().inputTracking(input);
        input.parentElement.classList.remove("error");
        input.parentElement.classList.add("correct");
        document
          .querySelector(`.form__input-error--${input.id}`)
          .classList.remove("displayed");
        return true;
      } else {
        input.parentElement.classList.remove("correct");
        input.parentElement.classList.add("error");
        validator().showErrorMsg(input);

        if (!notkg && typeof _satellite !== 'undefined') {
          _satellite.track('error', {
            errorType: 'user',
            errorCause: 'invalid input',
            errorMessage: input.name + ' field has not been filled correctly',
            errorCode: null,
            errorOrigin: 'form_validator'
          }
        );
        }

        return false;
      }
    },

    showErrorMsg: input => {
      document
        .querySelector(`.form__input-error--${input.id}`)
        .classList.add("displayed");
      let issue, issueType;
        console.log(input.id)
      switch (input.id) {
        case "firstname":
          issue = "prénom";
          issueType = "ne doit pas contenir de caractères spéciaux";
          break;
        case "lastname":
          issue = "nom";
          issueType = "ne doit pas contenir de caractères spéciaux";
          break;
        case "email":
          issue = "adresse email";
          issueType = "n'est pas valide";
          break;
        case "phone":
          issue = "numéro de téléphone";
          issueType = "n'est pas valide";
          break;
        case "address":
            issue = "adresse postale";
            issueType = "n'est pas reconnue";
          break;
        case "dealer":
          issue = "concessionnaire";
          issueType = "n'est pas reconnu";
          break;
        case "zipcode":
          issue = "code postal";
          issueType = "n'est pas reconnu";
          break;
        case "new_zipcode":
            issue = "code postal";
            issueType = "n'est pas reconnu";
            break;
        case "city":
          issue = "ville";
          issueType = "n'est pas reconnue";
          break;
        case "raison-sociale":
            issue = "raison sociale";
            issueType = "n'est pas valide";
            break;
        case "message":
          issue = "message";
          issueType = "ne doit pas contenir de caractères spéciaux";
          break;
        case "product":
          issue = "choix";
          break;
        case "owned-bike":
          issue = "moto";
          break;
      }
      if (issue) {
        if (input.type === 'select-one') {
          if ((input.options[input.selectedIndex].value === '')) {
            document.querySelector(
                `.form__input-error--${input.id} span`
            ).textContent = `Veuillez renseigner votre ${issue}`;
          }
        } else {
          if (input.value.length < 1) {
            document.querySelector(
              `.form__input-error--${input.id} span`
            ).textContent = `Veuillez renseigner votre ${issue}`;
          } else {
            document.querySelector(
              `.form__input-error--${input.id} span`
            ).textContent = `Votre ${issue} ${issueType}`;
          }
        }
      }
    },

    validateTypeMessage: input => {
      if (!(input.value.length >= 1) || input.value.length > 1500 || expSpCharTxt.test(input.value)) {
        return false;
      } else {
        return true;
      }
    },

    validateTypeText: input => {
      if (!(input.value.length >= 1) || expSpChar.test(input.value)) {
        return false;
      } else {
        return true;
      }
    },

    validateTypeEmail: input => {
      if (!expEmail.test(input.value)) {
        return false;
      } else {
        return true;
      }
    },

    validateTypeNativeSelect: input => {
      return (input.options[input.selectedIndex].value !== '');
    },

    validateTypeSelect: (label, testArray) => {
      if (label.getAttribute("data-value").length > 0) {
        testArray.push(true);
        label.parentElement.classList.remove("error");
        label.parentElement.parentElement.classList.remove("error");
      } else {
        testArray.push(false);
        label.parentElement.classList.add("error");
        label.parentElement.parentElement.classList.add("error");
      }
    },

    validateTypeNumber: input => {
      if (!expInteger.test(input.value)) {
        return false;
      } else {
        if(parseInt(input.getAttribute('max')) < parseInt(input.value)){
          return false;
        }else{
          return true;
        }
      }
    },
    validateTypeMonth: input => {
      if (!expMonth.test(input.value)) {
        return false;
      } else {
        return true;
      }
    },

    isNumber: e => {
      if (!expNumber.test(e.key)) {
        e.preventDefault();
        return false;
      }
      return true;
    },

    validateTypeRadio: (inputs, label, testArray) => {
      let isValid = false;
      if (!label.classList.contains('required')) {
        isValid = true;
      }

      for(let i=0; i < inputs.length; i++) {
       if (inputs[i].checked) {
         isValid = true;
         break;
       }
      }

      testArray.push(isValid);
      if (isValid) {
        label.parentElement.classList.remove("error");
        label.parentElement.parentElement.classList.remove("error");
      } else {
        label.parentElement.classList.add("error");
        label.parentElement.parentElement.classList.add("error");
      }

      return false;
    },
    validateTypePhone: input => {
      if (!input.classList.contains('required') && input.value.length === 0) {
        return true;
      }

      if (!expPhone.test(input.value)) {
        return false;
      } else {
        return true;
      }
    },

    validateTypeZipcode: input => {
      if (!expZipcode.test(input.value)) {
        return false;
      } else {
        return true;
      }
    },

    validateAddress: inputArray => {
      let validationArray = [];
      inputArray.forEach(input => {
        validationArray.push(validator().checkType(input));
      });
      if (!validationArray.indexOf(false) >= 0) {
        return true;
      } else {
        return false;
      }
    }
  };
};

export default validator;
